import React, { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";
import styled from "styled-components";
import LottiePlayer from "../../../components/media/lottiePlayer";

const Wrapper = styled.div`
  text-align: center;
  padding: 3rem 2rem;
  background: var(--bg-card);
  color: var(--text-main);
  border-radius: 12px;
  box-shadow: 0 6px 15px rgb(0 0 0 / 0.1);
  max-width: 450px;
  margin: 3rem auto;
  user-select: none;
`;

const Title = styled.h2`
  font-weight: 700;
  font-size: 2.25rem;
  margin-bottom: 0.5rem;
`;

const Message = styled.p`
  color: var(--text-secondary);
  font-size: 1.125rem;
  margin-bottom: 3rem;
  margin-top: 2rem;
  line-height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
`;

const InfoButton = styled(Button)`
  --btn-primary: var(--btn-primary);
  --btn-primary-hover: var(--btn-primary-hover);
  border-radius: 50%;
  width: 26px;
  height: 26px;
  padding: 0;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export default function CongratsStep({ onBuyMore, onExploreFeatures }) {
  const [infoVisible, setInfoVisible] = useState(false);

  return (
    <Wrapper>
      <Title>Congratulations!</Title>
      <LottiePlayer file={"https://lottie.host/ff5285c5-ef72-46f6-9fb4-46f1359e3e88/tti6w43LFu.json"} />
      <Message>
        You have received <strong>3 free credits</strong>
        <InfoButton
          type="button"
          icon="pi pi-info-circle"
          className="p-button-text p-button-info"
          aria-label="Info about credits"
          onClick={() => setInfoVisible(true)}
          tooltip="What are credits?"
          tooltipOptions={{ position: 'top' }}
        />
      </Message>

      <ButtonGroup>
        <Button
          label="Explore Features"
          onClick={onExploreFeatures}
          outlined
          className="p-button-raised p-button-secondary"
          style={{ minWidth: 140 }}
        />
        <Button
          label="Buy More"
          onClick={onBuyMore}
          className="p-button-raised p-button-success"
          style={{ minWidth: 140 }}
        />
      </ButtonGroup>

      <Dialog
        header="What are Credits?"
        visible={infoVisible}
        style={{ width: "400px" }}
        onHide={() => setInfoVisible(false)}
        modal
        closable
      >
        <p>
          Credits allow you to unlock full profiles of candidates. Each unlock costs one credit.
          Use credits to access detailed information like contact details, full experience, and endorsements.
          You start with 3 free credits and can buy more anytime.
        </p>
      </Dialog>
    </Wrapper>
  );
}
